module.exports = __webpack_public_path__ + "img/sixpackcarrier35.7af2109c.jpg";